import type { ReactNode } from "react";

import clsx from "clsx";

import styles from "./pill.module.css";

export type PillVariant = "default" | "outline";

type PillProps = {
	children: ReactNode;
	className?: string;
	variant?: PillVariant;
};
export function Pill({ children, className, variant = "default" }: PillProps): ReactNode {
	return (
		<span className={clsx("caption", styles.pill, styles[variant], className)}>{children}</span>
	);
}
